import React, { useEffect, useState } from "react";
import styles from "./TutorialInvite.module.scss";
import { GoPlus } from "react-icons/go";
import Slider from "react-slick";
import presets from "../../../pics/presets.png";
import acces from "../../../pics/acces.png";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { PermissionGate } from "../../superAdmin/managePermissions/PermissionGate";

// slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TutorialInvite = ({   user,
  roleLabel = "—",
  inviteCount = 0,
  usersCount = 0,
  expanded = false,
  onToggle,
  onInviteClick }) => {
  const [showMobile, setShowMobile] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const { t } = useTranslation();

  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
  };

  useEffect(() => {
    const handleResize = () => setShowMobile(window.innerWidth < 1300);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={styles.card}>
      <h3>{t("invite.my_users")}</h3>
      {/* ✅ BOUTON TOUT EN HAUT */}
      <div className={styles.inviteTop}>
        <button
          type="button"
          className={styles.btnPrimary}
          onClick={onToggle}
          id="btnInviteUserTutorial"
        >
          <GoPlus style={{ marginRight: 6 }} /> {t("invite.invite_a_user")}
        </button>
      </div>

      {/* HEADER */}
      <div className={styles.headerRow}>
        <h3 className={styles.title}>{t("invite.multiple_users_title")}</h3>

        <button
          type="button"
          className={`${styles.iconBtn} has-tooltip`}
          onClick={() => setShowGuide(true)}
          aria-label={t("invite.show_guide")}
        >
          <IoMdInformationCircleOutline />
        </button>
      </div>

      {/* TEXTE */}
      <p className={styles.text}>
        {t("invite.invite_text")}
      </p>

      {/* GUIDE OVERLAY */}
      {showGuide && (
        <div className={styles.guideOverlay}>
          <div className={styles.guideHeader}>
            <h4 className={styles.guideTitle}>{t("invite.guide_title")}</h4>
            <button
              className={styles.guideCloseIcon}
              onClick={() => setShowGuide(false)}
            >
              ✕
            </button>
          </div>

          <div className={styles.guideBody}>
            <div className={styles.steps}>
              <div className={styles.step}>
                <span className={styles.stepNb}>1</span>
                <span className={styles.stepText}>
                  Renseignez le formulaire d’invitation.
                </span>
              </div>

              <div className={styles.step}>
                <span className={styles.stepNb}>2</span>
                <span className={styles.stepText}>
                  L’utilisateur accepte via le lien reçu par mail.
                </span>
              </div>

              <div className={styles.step}>
                <span className={styles.stepNb}>3</span>
                <span className={styles.stepText}>
                  Il se connecte avec son compte ou en crée un.
                </span>
              </div>

              <div className={styles.step}>
                <span className={styles.stepNb}>4</span>
                <span className={styles.stepText}>
                  Attribuez les droits et l’accès à la cabine.
                </span>
              </div>
            </div>
          </div>

          <div className={styles.guideFooter}>
            <button
              className={styles.closeGuide}
              onClick={() => setShowGuide(false)}
            >
              {t("common.close")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TutorialInvite;